// export default interface RangeComponentProps {
//   data: RangeComponentData;
//   events?: RangeComponentEvents;
//   options?: RangeComponentOptions;
//   testId?: string;
// }

// export interface RangeComponentData {
//   mute?: boolean;
//   valueMax: number;
//   accessabiltyText?: string;
//   chapteredVideoData?: any;
//   reportTitle?: string;
// }

// export interface RangeComponentOptions {
//   preview?: string|any;
//   ghost?: boolean;
//   tooltipFormat?: TooltipFormat;
//   tooltip?: boolean;
//   reflect?: number;
//   className?: string;
//   title?: string;
// }

// export interface RangeComponentEvents {
//   update(value: number): void;
// }

export enum TooltipFormat {
  Timecode = "Timecode",
}
